import { connect } from 'react-redux';

import { Header, IHeaderProps } from './index';
import { IAppState } from '../../../common/state';

export const HeaderContainer = connect<IHeaderProps>((state: IAppState) => ({
  villageInfo: state.results.villageInfo,
  jsonQuery: state.results.jsonQuery,
  newbuildingInfo: state.newbuildingInformation,
  developerInfo: state.results.developerInfo,
  developerInfoRedesigned: state.results.developerInfoRedesigned,
}))(Header);
